import { AppMessage } from 'src/app/utils/in-app-comunication/types';

const CHANNEL_NAME = 'hyrox-app-channel';
let channel: BroadcastChannel | null = null;

export const initBroadcastChannel = () => {
  if (!channel && typeof window !== 'undefined' && 'BroadcastChannel' in window) {
    channel = new BroadcastChannel(CHANNEL_NAME);
  }
};

export const sendMessage = (message: AppMessage) => {
  initBroadcastChannel();
  channel?.postMessage(message);
};

export const onMessage = (handler: (msg: AppMessage) => void): (() => void) => {
  initBroadcastChannel();
  const listener = (event: MessageEvent) => {
    handler(event.data);
  };
  channel?.addEventListener('message', listener);
  return () => {
    channel?.removeEventListener('message', listener);
  };
};

export const closeBroadcastChannel = () => {
  channel?.close();
  channel = null;
};
